/** Desktop [272:7775](https://www.figma.com/design/w336KCNkLvp8mdckFFaN2B/RAPID-V1-DRAFTS?node-id=272-7775) */
export const MERCHANT_EMAIL_VERIFY_PATH = '/merchant/signup/verify'

export const MERCHANT_SIGNUP_OTP = '123456'

export const MERCHANT_SIGNUP_EMAIL_KEY = 'rapid_merchant_signup_email'

export const MERCHANT_EMAIL_VERIFICATION = {
  title: 'Verify Email',
  sentPrefix: "We've sent a 6-digit verification code to",
  resendPrompt: "Didn't receive the code?",
  resendLabel: 'Resend',
  resendCountdownPrefix: 'Resend in',
  verifyLabel: 'Verify Account',
  changeEmailLabel: 'Change Email Address',
  securityLabel: 'Secure 256-bit encryption',
  defaultEmail: 'm.daniels@enterprise.co',
  resendSeconds: 59,
}
